// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import UtilityAutomationApiClient from '../utils/UtilityAutomationApiClient';

export const UtilityAutomationApiContext = React.createContext<
  UtilityAutomationApiClient | undefined
>(undefined);

export const useUtilityAutomationClient: () => UtilityAutomationApiClient = () => {
  const utilityAutomationClient = useContext(UtilityAutomationApiContext);
  if (!utilityAutomationClient) {
    throw new Error(`Utility automation client not initialized`);
  }
  return utilityAutomationClient;
};
